import React, { useEffect, useState } from 'react';

import { Box, Paper, PaperProps, Typography } from '@mui/material';

import { Tooltip } from '~/components//Tooltip';
import { COLOR_DARK_OVERLAY, COLOR_LIGHT_OVERLAY } from '~/components/App/theme';
import { CanvasZoom } from '~/components/CanvasZoom';
import { LoaderOverlay } from '~/components/Loader';
import { ImageRetry } from '~/components/Retry';
import { useCanvas } from '~/contexts/CanvasContext';
import { useTooltipEventTracker } from '~/hooks/useTooltip';

interface IImageContainer extends Omit<PaperProps, 'ref'> {
  aspectRatio: number;
  children: React.ReactNode;
  isFetching?: boolean;
  isError?: boolean;
  isInitialLoading?: boolean;
  annotationenabled?:boolean;
  zoom?:boolean;
  refetch?: () => void;
}

export const ImageContainer = React.memo<IImageContainer>(function ImageContainer(props) {
  const { aspectRatio, isFetching, isError, isInitialLoading, refetch, children, zoom, ...others } = props;
  //const { zoom } = props;
  const { annotationEnabled } = useCanvas();
  const [showTooltip, events] = useTooltipEventTracker();
  const [useZoom, setUseZoom] = useState<boolean | undefined>(zoom);
  //console.log('ImageContainer zoom: ', zoom);
  //console.log('ImageContainer useZoom: ', useZoom);

  useEffect(() => {
    if (zoom) {
      //console.log('ImageContainer zoom: ', zoom);
      setUseZoom(false)
    }
  }, [zoom]);

  return (
    <Tooltip
      disableHoverListener
      disableFocusListener
      placement="right-start"
      noSpacing
      title={isFetching || isError || annotationEnabled ? null : (useZoom===undefined) ? <CanvasZoom {...events} /> : null }
      open={showTooltip}
      {...events}
    >
      <Paper
        component="main"
        sx={{
          background: 'transparent',
          position: 'relative',
          minWidth: 32,
          minHeight: 32 / aspectRatio,
          width: '100%',
          overflow: 'hidden',
          zIndex: 3,
        }}
        {...others}
      >
        <Box
          sx={[
            {
              position: 'relative',
              paddingBottom: `${(1 / aspectRatio) * 100}%`,
            },
          ]}
        >
          {isError && refetch && (
            <ImageRetry retry={refetch}>
              <Typography
                variant="h4"
                sx={{
                  mt: '24px',
                  maxWidth: '197px',
                  fontSize: '14px',
                  lineHeight: '18px',
                  textAlign: 'center',
                }}
              >
                Please refresh the page or try again later
              </Typography>
            </ImageRetry>
          )}
          {isFetching && <LoaderOverlay sx={{background: isInitialLoading ? COLOR_LIGHT_OVERLAY : COLOR_DARK_OVERLAY}} />}
          {children}
        </Box>
      </Paper>
    </Tooltip>
  );
});
